import PageHeader from "../components/PageHeader";
import { COMPANY } from "../data/content";

const sections = [
  {
    title: "1. Acceptance of Terms",
    body: `By accessing or using this website (${COMPANY.website}), you agree to these Terms of Use. If you do not agree, please do not use this website. This website is operated by ${COMPANY.name} ("Vaskion Technologies", "we", "us").`,
  },
  {
    title: "2. Purpose of This Website",
    body: "This website provides information about Vaskion Technologies and its software development, AI and IT services, and allows visitors to contact us. The content on this website is for general information only and does not constitute professional advice or a binding offer.",
  },
  {
    title: "3. Intellectual Property",
    body: `All content on this website — including text, design, graphics and the Vaskion logo — is the property of ${COMPANY.name} or its licensors and is protected by applicable intellectual property laws. You may not reproduce, modify or redistribute any content without our prior written consent.`,
  },
  {
    title: "4. Acceptable Use",
    body: "You agree to use this website only for lawful purposes and in a way that does not infringe the rights of others or restrict their use of the website. You must not attempt to gain unauthorised access to the website, its servers or any connected systems.",
  },
  {
    title: "5. Information You Submit",
    body: "When you submit an enquiry through this website, you confirm that the information you provide is accurate and that you have the right to share it. How we handle that information is described in our Privacy Policy.",
  },
  {
    title: "6. No Warranty",
    body: 'This website and its content are provided "as is" without warranties of any kind, express or implied. While we take care to keep information accurate and current, we do not guarantee that the website will be error-free or uninterrupted.',
  },
  {
    title: "7. Limitation of Liability",
    body: "To the extent permitted by law, Vaskion Technologies will not be liable for any indirect, incidental or consequential damages arising from your use of, or inability to use, this website.",
  },
  {
    title: "8. Third-Party Links",
    body: "This website may contain links to third-party websites. We are not responsible for the content or practices of those websites.",
  },
  {
    title: "9. Governing Law",
    body: "These Terms of Use are governed by the laws of India. Any disputes arising from the use of this website will be subject to the jurisdiction of the courts in India.",
  },
  {
    title: "10. Changes to These Terms",
    body: "We may update these Terms of Use from time to time. The current version will always be published on this page.",
  },
  {
    title: "11. Contact",
    body: `For any questions about these Terms of Use, please contact us at ${COMPANY.email}.`,
  },
];

const TermsOfUse = () => (
  <main data-testid="terms-of-use-page">
    <PageHeader
      eyebrow="Legal"
      title="Terms of Use"
      description="The terms that govern your use of this website."
    />
    <section className="bg-white py-16 lg:py-20">
      <div className="container-site max-w-3xl">
        {sections.map((section) => (
          <article key={section.title} className="border-b border-border py-8 first:pt-0 last:border-0">
            <h2 className="text-lg font-semibold">{section.title}</h2>
            <p className="mt-3 text-base leading-relaxed text-brand-grey">{section.body}</p>
          </article>
        ))}
        <p className="mt-8 text-sm text-neutral-500">Last updated: 2026.</p>
      </div>
    </section>
  </main>
);

export default TermsOfUse;
